import { createSelector, createStructuredSelector } from 'reselect';
import { NameSpace } from '../../enum';
import { RootState } from '../../interface';
import { initialState } from './reducer';

/**
 * Selects the container's state from RootState based on the given namespace
 * @param {RootState} state - rootstate of the app
 * @returns {AppState} - the App container's state
 */
export const selectState = (state: RootState) => state[NameSpace.ADDRESS_VALIDATION] || initialState;

export const selectAddresses = createSelector(selectState, state => state.addresses);
export const selectSelectedAddress = createSelector(selectState, state => state.selectedAddress);
export const selectForm = createSelector(selectState, state => state.addressForm);
export const selectIsLeadManagement = createSelector(selectState, state => state.productSuggestion?.isLeadManagement);
export const selectSuggestions = createSelector(selectState, state => state.productSuggestion);
export const selectPrimary = createSelector(selectState, state => state.productSuggestion?.primary);
export const selectSecondary = createSelector(selectState, state => state.productSuggestion?.secondary);
export const selectError = createSelector(selectState, state => state.error);

/**
 * Create a structured selector. (Map our selectors into specific keys in an object)
 * Used to connect the state to the container
 */
export const mapStateToProps = createStructuredSelector({
    form: selectForm,
    addresses: selectAddresses,
    selectedAddress: selectSelectedAddress,
    error: selectError,
});
